var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 243.9 72.5",
    style: {
      enableBackground: "new 0 0 243.9 72.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#313D47;} .st1{fill:#45A09E;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.3,14.5 135.3,14.5 135.3,38.4 120.5,38.4 120.5,14.5 117.6,14.5 117.6,41 138.2,41 138.2,43.5 141.1,43.5 141.1,38.4 138.3,38.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "147.2,29 161.5,29 161.5,26.3 147.2,26.3 147.2,17.1 161.8,17.1 161.8,14.5 144.2,14.5 144.2,41 162.1,41 162.1,38.4 147.2,38.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "182.9,26.3 168.1,26.3 168.1,14.5 165.2,14.5 165.2,41 168.1,41 168.1,28.9 182.9,28.9 182.9,41 185.9,41 185.9,14.5 182.9,14.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "188.9,14.5 188.9,17.1 198.5,17.1 198.5,41 201.5,41 201.5,17.1 211.1,17.1 211.1,14.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.3,27.6c1.6-1.4,2.6-3.5,2.6-5.7c0-2.4-0.9-4.5-2.7-5.9c-1.9-1.6-3.8-1.7-6-1.7h-13v26.8h3V29.3h10 C229.6,29.3,231.4,29.2,233.3,27.6L233.3,27.6z M217.2,17.4h10c1.6,0,3.1,0,4.4,1.3c0.8,0.7,1.2,1.9,1.2,3.2 c0,1.3-0.5,2.4-1.2,3.2l0,0c-1.3,1.3-2.8,1.3-4.4,1.3h-10V17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.3,14.3H36.9l0,3.8h15.4c4.5,0,8.3,3.3,9.2,7.6H41.3v3.6h20.2c-0.8,4.4-4.6,7.6-9.2,7.6H36.9v3.8h15.4 c3.6,0,6.9-1.5,9.3-3.9c2.4-2.4,3.9-5.7,3.9-9.3C65.5,20.2,59.6,14.3,52.3,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,25.6H71.7v-7.5h20.8v-3.8H68v26.4h19.1c4.3,0,7.6-3.3,7.6-7.6C94.8,29.5,92,25.7,87.2,25.6L87.2,25.6z M87.1,36.9H71.7v-7.6h15.5c2.1,0,3.8,1.7,3.8,3.8S89.3,36.9,87.1,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,27.1c2.9-3,2.8-7.8-0.2-10.7c-1.4-1.3-3.3-2.1-5.2-2.1H9.1v26.4h18.4c4.2,0,7.6-3.4,7.6-7.6 C35.1,30.8,34.1,28.6,32.3,27.1z M12.7,18.1h14.1c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8H12.7V18.1z M27.5,36.9H12.7v-7.6h14.8 c2.1,0,3.8,1.7,3.8,3.8S29.6,36.9,27.5,36.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.4,
    y: 10.4,
    className: "st1",
    width: 3.3,
    height: 34.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,55.9v8.5h-2v-6.9h-3.8v6.9h-2v-8.5H39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,59c0,1.9-1.4,3.1-3.7,3.1h-1.7v2.3h-2v-8.5h3.7C47.5,55.9,49,57.1,49,59z M47,59c0-0.9-0.6-1.5-1.8-1.5 h-1.6v2.9h1.6C46.4,60.4,47,59.9,47,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.8,60.1c0-2.5,2-4.4,4.6-4.4c2.7,0,4.6,1.9,4.6,4.4c0,2.5-2,4.4-4.6,4.4C51.7,64.5,49.8,62.7,49.8,60.1z M57.1,60.1c0-1.6-1.1-2.7-2.7-2.7c-1.5,0-2.7,1.1-2.7,2.7c0,1.6,1.1,2.7,2.7,2.7C55.9,62.8,57.1,61.7,57.1,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,60.1c0-2.6,2-4.4,4.6-4.4c1.5,0,2.7,0.5,3.5,1.5l-1.3,1.2c-0.6-0.7-1.3-1-2.1-1c-1.6,0-2.7,1.1-2.7,2.7 c0,1.6,1.1,2.7,2.7,2.7c0.8,0,1.6-0.3,2.1-1l1.3,1.2c-0.8,1-2,1.5-3.5,1.5C62,64.5,60,62.7,60,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.8,57.5h-2.7v6.9h-1.9v-6.9h-2.7v-1.6h7.4V57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.4,59c0,1.9-1.4,3.1-3.7,3.1H79v2.3h-2v-8.5h3.7C82.9,55.9,84.4,57.1,84.4,59z M82.4,59 c0-0.9-0.6-1.5-1.8-1.5H79v2.9h1.6C81.8,60.4,82.4,59.9,82.4,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91,62.6H87l-0.8,1.8h-2l3.8-8.5H90l3.8,8.5h-2.1L91,62.6z M90.4,61.1L89,57.8l-1.3,3.2H90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,55.9v8.5h-2v-3.5h-3.9v3.5h-2v-8.5h2v3.3h3.9v-3.3H102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,60.1c0-2.6,2-4.4,4.6-4.4c1.5,0,2.7,0.5,3.5,1.5l-1.3,1.2c-0.6-0.7-1.3-1-2.1-1c-1.6,0-2.7,1.1-2.7,2.7 c0,1.6,1.1,2.7,2.7,2.7c0.8,0,1.6-0.3,2.1-1l1.3,1.2c-0.8,1-2,1.5-3.5,1.5C106.2,64.5,104.2,62.7,104.2,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120,57.5h-2.7v6.9h-1.9v-6.9h-2.7v-1.6h7.4V57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.7,62c0,1.5-1.2,2.4-3.3,2.4h-4.2v-8.5h4c2,0,3.1,0.8,3.1,2.2c0,0.9-0.4,1.5-1.2,1.9 C128.2,60.3,128.7,61,128.7,62z M123.2,59.4h1.8c0.8,0,1.3-0.4,1.3-1c0-0.7-0.4-1-1.3-1h-1.8V59.4z M126.7,61.8 c0-0.7-0.5-1.1-1.4-1.1h-2.2v2.1h2.2C126.3,62.9,126.7,62.6,126.7,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.7,60.1c0-2.5,2-4.4,4.6-4.4c2.7,0,4.6,1.9,4.6,4.4c0,2.5-2,4.4-4.6,4.4C131.6,64.5,129.7,62.7,129.7,60.1 z M137,60.1c0-1.6-1.1-2.7-2.7-2.7c-1.5,0-2.7,1.1-2.7,2.7c0,1.6,1.1,2.7,2.7,2.7C135.8,62.8,137,61.7,137,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.3,59c0,1.9-1.4,3.1-3.7,3.1h-1.7v2.3h-2v-8.5h3.7C149.8,55.9,151.3,57.1,151.3,59z M149.3,59 c0-0.9-0.6-1.5-1.8-1.5h-1.6v2.9h1.6C148.7,60.4,149.3,59.9,149.3,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.9,62.6h-3.9l-0.8,1.8h-2l3.8-8.5h1.9l3.8,8.5h-2.1L157.9,62.6z M157.3,61.1l-1.3-3.2l-1.3,3.2H157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.2,62c0,1.6-1.7,2.5-3.8,2.5c-1.1,0-2.3-0.3-3.4-0.9l0.6-1.4c0.8,0.5,1.7,0.7,2.5,0.7c1.1,0,2-0.4,2-1.2 c0-0.6-0.6-1-1.5-1h-2.1v-1.5h1.9c0.8,0,1.3-0.4,1.3-0.9c0-0.7-0.8-1.1-1.7-1.1c-0.7,0-1.6,0.2-2.3,0.6l-0.6-1.5 c0.9-0.5,1.9-0.7,2.9-0.7c2,0,3.7,0.9,3.7,2.4c0,0.8-0.5,1.5-1.2,1.8C167.6,60.3,168.2,61,168.2,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.2,62c0,1.5-1.2,2.4-3.3,2.4h-4.2v-8.5h4c2,0,3.1,0.8,3.1,2.2c0,0.9-0.4,1.5-1.2,1.9 C176.7,60.3,177.2,61,177.2,62z M171.7,59.4h1.8c0.8,0,1.3-0.4,1.3-1c0-0.7-0.4-1-1.3-1h-1.8V59.4z M175.3,61.8 c0-0.7-0.5-1.1-1.4-1.1h-2.2v2.1h2.2C174.8,62.9,175.3,62.6,175.3,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.8,55.9h2v5.5l4-5.5h1.8v8.5h-1.9v-5.5l-4,5.5h-1.9V55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.2,57.5h-2.7v6.9h-1.9v-6.9h-2.7v-1.6h7.4V57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.5,55.9h2v5.5l4-5.5h1.8v8.5h-1.9v-5.5l-4,5.5h-1.9V55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.2,55.9v8.5h-1.9v-2.3h-1.8l-1.5,2.3h-2.1l1.8-2.6c-1.1-0.5-1.8-1.4-1.8-2.8c0-2,1.4-3.2,3.7-3.2H213.2z M207.9,59c0,1,0.6,1.5,1.7,1.5h1.7v-3.1h-1.7C208.5,57.5,207.9,58,207.9,59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.a252cb23db28a0b4c555682bdaa38c77.svg";
export { ForwardRef as ReactComponent };